import apiHeader from '@/helpers/apiHeader';

const manufacturerService = {
    list(params) {
        return apiHeader.get('general-master-data/manufacturer', { params });
    },
    create(params) {
        return apiHeader.post('general-master-data/manufacturer', params);
    },
    detail(id) {
        return apiHeader.get(`general-master-data/manufacturer/${id}`);
    },
    patch(id, params) {
        return apiHeader.patch(`general-master-data/manufacturer/${id}`, params);
    },
    delete(id) {
        return apiHeader.delete(`general-master-data/manufacturer/${id}`);
    },
}

export default manufacturerService; 